const mobile = {
  path: "/mobile",
  name: "mobile",
  redirect: "/mobile/home",
  component: {
    render: c => c("router-view")
  },
  title: "科云官网",
  children: [
    {
      path: "/mobile/home",
      name: "mobileHome",
      component: () => import("@/views/mobile/home/index.vue"),
      title: "科云新零售"
    }
  ]
};

export default mobile;
